module.exports = __webpack_public_path__ + "Flag-208.e60c493fdbe69069d943ecc37287aa90.svg";